var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[(_vm.content !== null && _vm.addressObj !== null )?_c('single-map',{staticClass:"map-container",staticStyle:{"height":"586px!important"},attrs:{"content":_vm.content,"addressObj":_vm.addressObj}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }